import SortableItem from "@/components/SortableItem";
import { BoltDisplayField, BoltDisplayPage } from "@WahooFitness/crux-js-display-cfg";
import { MouseEvent, useCallback, useMemo } from "react";
import WorkoutPageField from "./WorkoutPageField";

function SortableWorkoutFieldRow({
  field,
  index,
  total,
  page,
  openCategoryDialog,
  removeField,
}: {
  field: BoltDisplayField;
  index: number;
  total: number;
  page?: BoltDisplayPage | undefined | null;
  openCategoryDialog: (field: BoltDisplayField) => void;
  removeField: (field: BoltDisplayField) => void;
}) {
  const id = useMemo(() => field.getId().toString(), [field]);
  const fieldPosition = useMemo(
    () => (page ? page.getIndexOfField(field) + 1 : undefined),
    [page, field]
  );

  const handleFieldClick = useCallback(() => {
    openCategoryDialog(field);
  }, [openCategoryDialog, field]);

  const handleFieldRemove = useCallback(
    (e: MouseEvent<Element>) => {
      e.preventDefault();
      e.stopPropagation();
      removeField(field);
    },
    [removeField, field]
  );

  const isFirstField = index === 0;
  const isLastField = index === total - 1;

  return (
    <SortableItem id={id}>
      <WorkoutPageField
        id={id}
        field={field}
        isEditable={true}
        onFieldClick={handleFieldClick}
        onFieldRemove={handleFieldRemove}
        fieldPosition={fieldPosition}
        isFirstField={isFirstField}
        isLastField={isLastField}
      />
    </SortableItem>
  );
}

export default SortableWorkoutFieldRow;
